// extracted by mini-css-extract-plugin
export const content = "about-style-module--content--1bktl";
export const btnSty = "about-style-module--btnSty--2Gurv";
export const tooltip = "about-style-module--tooltip--1zVQf";
export const tooltiptext = "about-style-module--tooltiptext--uoLJR";